import PortalIdParser from 'PortalIdParser';
import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET collector/v3/data-query/definitions/path//{queryPath}
 */
export function fetchGraphqlVariables(queryPath, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`collector/v3/data-query/definitions/path/${queryPath}/filters?${PortalIdParser.get()}`);
}